module.exports = __webpack_public_path__ + "static/media/fk.2d1b653b.svg";